export enum platformLightboxQueryParams {
  LIGHTBOX_ID = 'lightboxId',
  LIGHTBOX_DETAIL_INDEX = 'lightboxDetailIndex',
  LIGHTBOX_GRID_VIEW = 'lightboxGridView',
  LIGHTBOX_GRID_SCALE = 'lightboxGridScale',
}
